import {ebus} from '@/vendor/ebus';

// export const walletEnvironment = 'TEST';
export const walletEnvironment =  'PRODUCTION';

// https://test.saferpay.com/BO/Settings/FieldsAccessToken
export const accessToken = '4acca9b5-b968-460e-8859-f8cbe0a497e4';
// export const accessToken = 'af1f890f-a8e2-4aeb-94ef-ad674879d1cd';
// for vtest39: af1f890f-a8e2-4aeb-94ef-ad674879d1cd
// for qdev: 29a11d0c-3a1e-400d-87d3-e0d755a14e0d
export const customerId = '364748'; // from backoffice loginname

export const googleGateway = 'worldlinesaferpay';
export const googleGatewayMerchantId = '17774047'; // the terminalId from the backoffice

//merchantId can be found on https://pay.google.com/business/console/
export const googlePayMerchantId = 'BCR2DN4T7XZLXPYV';

// work in progress
